// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fdJuP","newExpiryDate":"styles_newExpiryDate__1hTQt","footer":"styles_footer__80Sih"};